﻿const LfStyleDefs = {
    breaks: {
        xxsmall: 375,
        xsmall: 414,
        small: 767,
        medium: 1024,
        large: 1200
    },
    fonts: {
        heading: 'VAG Rounded, sans-serif',
        main: 'Muli, sans-serif',
        icons: 'lararforsakringar'
    },
    colors: {
        almostBlack: '#182329',
        blueBackground: '#0073bd',
        blueButtonLighter: '#4388C3',
        blueButtonDarker: '#2B69A9',
        grayText: '#8b9194',
        grayBorder: '#dbdee0',
        grayBackground: '#fcfcfc',
        grayBackgroundDarker: '#f5f5f5',
        grayBackgroundDarkest: '#ececec',
        green: '#00b04c',
        orange: '#f68b29',
        error: '#cf3d79',
        lightError: '#f79ac0'
    },
    iconCodes: {
        facebook: '\\e900',
        twitter: '\\e901',
        search: '\\e926',
        arrowDown: '\\e902',
        arrowLeft: '\\e903',
        arrowRight: '\\e904',
        arrowUp: '\\e905',
        arrowUpDown: '\\e911',
        checkCircle: '\\e906',
        check: '\\e907',
        chevDown: '\\e908',
        chevLeft: '\\e909',
        chevRight: '\\e90a',
        chevUp: '\\e90b',
        downloadCircleFilled: '\\e90c',
        downloadCircle: '\\e90d',
        download: '\\e90e',
        gridIcon: '\\e90f',
        healthCross: '\\e910',
        heart: '\\e911',
        home: '\\e912',
        informationIcon: '\\e914',
        iconSearch: '\\e926',
        iconSignOut: '\\e927',
        iconX: '\\e93d',
        lararforbundet: '\\e929',
        lararnasriksforbund: '\\e93b',
        iconExternalLink: '\\e92a',
        upDownArrow: '\\e913',
        plus: '\\e92e',
        plus2: '\\e930',
    }
};

export default LfStyleDefs;
